/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Nda_Pending_NoticeInputs */



/**
* | output |
* | --- |
* | "A playtest NDA is awaiting your signature." |
*
* @param {Profile_Nda_Pending_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_nda_pending_notice = /** @type {((inputs?: Profile_Nda_Pending_NoticeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Nda_Pending_NoticeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un NDA de playtest attend votre signature.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Un NDA de playtest espera su firma.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Um NDA de playtest aguarda sua assinatura.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un NDA di playtest attende la tua firma.")
	return /** @type {LocalizedString} */ ("A playtest NDA is awaiting your signature.")
});